module.exports = ".table-hover > tbody > tr:hover {\n    background-color: #e7f0f7 !important\n}\n\n.panel-heading {\n    padding: 6px 15px;\n}\n\n.panel-body {\n    padding: 10px;\n}\n\n.form-group {\n    margin-bottom: 8px;\n}\n\n.dropdown-link {\n    text-decoration: none;\n    color: #4e4e4e\n}\n\n.col-md-1-5 {\n    width: 11.66666667%;\n}\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pesquisa-fluxo/pesquisa-fluxo.component.css
// module id = ./src/app/pesquisa-fluxo/pesquisa-fluxo.component.css
// module chunks = main